import { FieldAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import Controller, { OnCancel, OnMount, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isMobileResolution } from '@philips-internal/oswald-ui-utils';
import { FragmentNames, SuggestionTypeConsultationAliases } from '../../codegen';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { ContextType, SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

@Controller ({ fragment: FragmentNames.SUGGESTION_TYPE_CONSULTATION })
export default class SuggestionTypeConsultationController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContextAPI!: SubmittableFragmentContext;

  @OnMount({ target: SuggestionTypeConsultationAliases.RADIO_GROUP_TYPE_CONSULTATION })
  onMountRadioGroup( evt: MountEvent ): void {
    const radioGroup = evt.target as RadioGroupAPI;
    const indentifyTypes: SelectableItem[] = [
      {key: 'S', label: MessageService.translate('patient.teleconsultation'), value: 'S'},
      {key: 'N', label: MessageService.translate('text.in-person'), value: 'N'}
    ];
    radioGroup.setData(indentifyTypes);
  }

  @OnMount ({ target: SuggestionTypeConsultationAliases.FIELD_SUGGESTION_TYPE_CONSULTATION})
  onMountFieldSuggestionTypeConsultation ( evt: MountEvent ): void {
    const fieldApi = evt.target as FieldAPI;
    if (isMobileResolution()){
      fieldApi.setWidth(2);
    }
  }

  @OnSubmit ({ target: SuggestionTypeConsultationAliases.FORM_SUGGESTION_TYPE_CONSULTATION})
  onSubmitFormSuggestionTypeConsultation ( evt: SubmitEvent ): void {
    this.submittableFragmentContextAPI.submit(new SubmitEvent({ record: evt.record }));
  }

  @OnCancel ({ target: SuggestionTypeConsultationAliases.FORM_SUGGESTION_TYPE_CONSULTATION})
  onCancelFormSuggsetionTypeConsultation (): void {
    this.submittableFragmentContextAPI.cancel(new SubmitEvent());
  }

}